var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            !_vm.isSuccess
              ? _c(
                  "form",
                  {
                    staticClass: "login-form custom-form m-t-5 p-t-5",
                    attrs: { id: "login-form", novalidate: "" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.onSubmit)
                      }
                    }
                  },
                  [
                    _c("ValidationProvider", {
                      attrs: { mode: "lazy", rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "p-t-5 two-factor-auth-description"
                                  },
                                  [
                                    _c("h1", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "INPUT_TWO_FACTOR_TITLE",
                                          expression: "'INPUT_TWO_FACTOR_TITLE'"
                                        }
                                      ],
                                      staticClass:
                                        "title md-title title--ringba"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "login-form__field two-factor-auth-description"
                                  },
                                  [
                                    !_vm.isTwoFactorAuthEmailOrSMS
                                      ? _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t(
                                                "TWO_FACTOR_FORM_APP_INSTRUCTION"
                                              )
                                            )
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isTwoFactorAuthEmailOrSMS
                                      ? _c("span", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value:
                                                "TWO_FACTOR_FORM_DELIVERY_INSTRUCTION",
                                              expression:
                                                "'TWO_FACTOR_FORM_DELIVERY_INSTRUCTION'"
                                            }
                                          ]
                                        })
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "login-form__field input__wrap",
                                    class: { "error-focus": errors.length > 0 }
                                  },
                                  [
                                    _c("div", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.validationCode,
                                            expression: "validationCode"
                                          }
                                        ],
                                        ref: "validationCodeInput",
                                        staticClass:
                                          "login-form__field__input required",
                                        class: {
                                          error: errors.length > 0,
                                          valid:
                                            _vm.validationCode.length > 0 &&
                                            errors.length == 0
                                        },
                                        attrs: {
                                          id: "validationCode",
                                          disabled: _vm.isPending,
                                          name: "validationCode",
                                          required: ""
                                        },
                                        domProps: { value: _vm.validationCode },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) return
                                            _vm.validationCode =
                                              $event.target.value
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        directives: [
                                          {
                                            name: "t",
                                            rawName: "v-t",
                                            value: "INPUT_TWO_FACTOR_CODE",
                                            expression:
                                              "'INPUT_TWO_FACTOR_CODE'"
                                          }
                                        ],
                                        staticClass: "login-form__field__label",
                                        attrs: { for: "userName" }
                                      }),
                                      _vm._v(" "),
                                      errors.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "error-tooltip__wrap"
                                            },
                                            [
                                              _c("h4", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value:
                                                      "INPUT_TWO_FACTOR_CODE_ERROR",
                                                    expression:
                                                      "'INPUT_TWO_FACTOR_CODE_ERROR'"
                                                  }
                                                ],
                                                staticClass:
                                                  "menu-link text-uppercase error-tooltip__content"
                                              }),
                                              _vm._v(" "),
                                              _c("p", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value:
                                                      "INPUT_TWO_FACTOR_CODE_ERROR_DESCRIPTION",
                                                    expression:
                                                      "'INPUT_TWO_FACTOR_CODE_ERROR_DESCRIPTION'"
                                                  }
                                                ],
                                                staticClass: "description"
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "fieldset",
                      {
                        staticClass:
                          "login-form__field login-form__field--button"
                      },
                      [
                        _c(
                          "SubmitButton",
                          { attrs: { pending: _vm.isPending } },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("VALIDATE_TWO_FACTOR_BUTTON")) +
                                " \n      "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "button button--transparent-grad pulse m-t-10",
                              attrs: { href: "#" },
                              on: { click: _vm.onGoBack }
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_vm.$t(_vm.backButtonDescription)) +
                                  "\n        "
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "backend-error-fade" } },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showErrorMsg,
                                expression: "showErrorMsg"
                              }
                            ],
                            staticClass: "text-center p-t-5"
                          },
                          [
                            _c("p", { staticClass: "text-danger" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.actionStatus.error) +
                                  "\n        "
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "p-t-10 two-factor-auth-description",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("TWO_FACTOR_FORM_APP_ADDITIONAL_INSTRUCTION")
                        )
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }